<template lang='pug'>
  table-list(
    :headers='headers'
    :items='notifications'
    :total='notifications.length'
    item-key='index'
    :has-selection='false'
    :select-all='false'
    no-pagination)
    template(v-slot:empty)
      v-container
        v-row
          v-col(align='center' justify='center')
            .text-h5.grey--text No Notifications Defined
            v-btn(text color='accent' @click='createNotification') Create Notification
    template(v-slot:row='{item, index, expanded}')
      // <tr> (Gets put inside tr)
      td {{item.type}}
      td
        chip-names(v-model='item.testSuites')
      td {{item.trigger.join(', ')}}
      td {{formatTarget(item.target)}}
      td
        v-row(justify='end')
          v-tooltip(bottom)
            template(v-slot:activator='{on}')
              v-btn(v-on='on' text icon @click='removeNotification(index)')
                v-icon delete
            span Delete
          v-tooltip(bottom)
            template(v-slot:activator='{on}')
              v-btn(v-on='on' text icon @click='editNotification(index)')
                v-icon edit
            span Edit
      // </tr> (Gets put inside tr)
    template(v-slot:item='{item}')
      v-row(no-gutters)
        v-col(cols='12').text-body-1.pa-6
          v-row.text-subtitle-1
            v-col
              | Send {{aAn(item.type)}}
              strong &nbsp;{{item.type}}&nbsp;
              | to
              strong &nbsp;{{formatTarget(item.target)}}&nbsp;
              | on {{item.trigger.join(', ')}} for the following suites:
              chip-names(v-model='item.testSuites')
          v-row(justify='end')
            v-tooltip(bottom)
              template(v-slot:activator='{on}')
                v-btn(v-on='on' text icon @click='removeNotification(index)')
                  v-icon delete
              span Delete
            v-tooltip(bottom)
              template(v-slot:activator='{on}')
                v-btn(v-on='on' text icon @click='editNotification(index)')
                  v-icon edit
              span Edit
      v-divider
</template>

<script>
import {isString, isArray} from 'lodash';
import TableMixin from '@/mixins/table.mixin';
import Notifications from '@/services/notification.service';
import TableList from '@/components/TableList';
import ChipNames from '@/components/ChipNames';

export default {
  components: {ChipNames, TableList},
  mixins: [TableMixin],
  name: 'BionicMetricsNotificationsTable',
  props: {
    notifications: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    aAn(type) {
      if (type === 'Email') return 'an';
      return 'a';
    },
    formatTarget(target) {
      if (!target) return target;
      if (isString(target)) return target;
      if (isArray(target)) return target.join(', ');
      const {name, id} = target;
      if (name && id) return `${name} (${id})`;
      return target;
    },
    editNotification(index) {
      this.$emit('edit', index);
    },
    createNotification() {
      this.$emit('create');
    },
    async removeNotification(index) {
      const yes = await Notifications.confirm('Remove', 'Are you sure you want to remove this notification?');
      if (!yes) return;
      this.$emit('remove', index);
    }
  },
  data() {
    return {
      headers: [
        {text: 'Type', value: 'type', sortable: false},
        {text: 'Suites', value: 'testSuites', sortable: false},
        {text: 'Notify On', value: 'trigger', sortable: false},
        {text: 'Target', value: 'target', sortable: false},
        {text: '', value: 'actions', sortable: false}
      ]
    };
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
